// AtomParts/Button.tsx
import React from "react";

interface ButtonProps {
  type?: string;
  label: string;
  url: string;
  size?: string;
}

export const Button: React.FC<ButtonProps> = ({ type, label }) => {
  return <button className={type}>{label}</button>;
};
